import React from 'react';

export default () => (
    <section className="white-bg">
        <div id="SMARTPHONE_BANNER_ANY" />
    </section>
);
